export default __webpack_public_path__ + "static/media/sample-hospital-bg.ee22bf7a.png";